import React, { memo } from 'react';
import { Flex, Text } from 'pcln-design-system';
import { ArrowUp, DollarCircle, Dot, Luggage, Pin, Seat, Smartphone, Success } from 'pcln-icons';
import ContentfulRichText from '../ContentfulRichText';
const icons = {
  ArrowUp,
  DollarCircle,
  Luggage,
  Pin,
  Seat,
  Smartphone,
  Success
};
/** @public */
function ContentfulListItem({
  iconName,
  label,
  ...props
}) {
  const Icon = icons[iconName] || Dot;
  return React.createElement(Flex, {
    ...props
  }, React.createElement(Icon, {
    size: 14,
    title: iconName || 'Dot',
    mr: 2
  }), label.data ? React.createElement(ContentfulRichText, {
    body: label,
    fontSize: 0,
    m: 0
  }) : React.createElement(Text, {
    fontSize: 0
  }, label));
}
export default memo(ContentfulListItem);